var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3421_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51074 3.9689V2.62937C4.51074 2.09624 4.94695 1.66003 5.48008 1.66003H10.5207C11.0538 1.66003 11.49 2.09624 11.49 2.62937V3.9689",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35156 8.33093V13.4375C1.35156 13.9339 1.75777 14.34 2.25405 14.34H5.09702",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31553 9.67837C2.77715 9.33085 0.75 8.46803 0.75 7.08993V4.95413C0.75 4.45706 1.1554 4.05164 1.65249 4.05164H14.3475C14.8446 4.05164 15.25 4.45709 15.25 4.95413V6.24772",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 14.34V12.59C7.0835 10.657 8.6505 9.09003 10.5835 9.09003H11.7502V7.92336C11.7502 7.60119 12.0113 7.34003 12.3335 7.34003C12.4946 7.34003 12.6404 7.40533 12.746 7.51089L15.0793 9.84422C15.1849 9.94977 15.2502 10.0956 15.2502 10.2567C15.2502 10.4178 15.1849 10.5636 15.0793 10.6692L12.746 13.0025C12.6404 13.1081 12.4946 13.1734 12.3335 13.1734C12.0113 13.1734 11.7502 12.9122 11.7502 12.59V11.4234H9.41683C8.12816 11.4234 7.0835 12.468 7.0835 13.7567",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3421_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyJobIcon);
export default __webpack_public_path__ + "static/media/apply-job-icon.7beccccdd5256e28ac352dc1ec040822.svg";
export { ForwardRef as ReactComponent };